/**
 * Popup Coordinator
 * 
 * Manages popup priority when multiple targeted popups match a single customer.
 * Ensures only the highest-priority popup displays, preventing stacking and conflicts.
 * 
 * 1. Queries DOM for all <pop-up> elements that passed Liquid targeting filters
 * 2. Sorts popups by priority (data-priority attribute, 1-10 scale)
 * 3. Removes lower-priority popups from DOM before they initialise
 * 4. Highest priority popup displays normally
 * 
 * Performance: Runs once on page load before popup initialisation.
 * Subsequent runs detect only the winning popup and skip co-ordination.
 * 
 * @author Alec Hewstone (Kubix Media)
 * @date 12/11/2025
 */

(() => {
    const coordinatePopups = () => {
      const popups = Array.from(document.querySelectorAll('pop-up'));
      
      // No co-ordination needed for 0 or 1 popup
      if (popups.length <= 1) return;
  
      // Sort popups by priority (highest first)
      const sortedPopups = popups
        .map(popup => ({
          element: popup,
          priority: parseInt(popup.dataset.priority) || 5,
          id: popup.id
        }))
        .sort((a, b) => b.priority - a.priority);
  
      // Keep higher-priority popups, remove lower-priority popups
      const [winner, ...losers] = sortedPopups;
      losers.forEach(popup => popup.element.remove());
    };
  
    // Run when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', coordinatePopups);
    } else {
      coordinatePopups();
    }
  })();